/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { LIST_ASSETS } from "../pages/Assets/graphql/created-assets.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { TEST_DATA} from "../pages/Assets/config/default.blueprint"
import _ from "lodash";
import {SOUND ,VIDEO} from "../assets"

import React from "react";






const MODULE_NAME = "AssetsService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

interface IProps{
    imageServer:any
}

export class AssetsService {
    private static instance: AssetsService;
    private vapp: VApplication;
    private imageServer;
    private constructor(props: IProps | any = {}) {
        this.vapp = VApplication.getInstance();
        this.imageServer = props?.imageServer
    }
    public static getInstance(props:IProps | any = {}): AssetsService {
        if (!AssetsService.instance) {
            AssetsService.instance = new AssetsService(props);
        }
    
        return AssetsService.instance;
    }

   
      
    

    

    async getAssets(size: number, offset: number) {
        const getassetsService = AssetsService.getInstance();
        console.log("serrver",getassetsService.imageServer)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: LIST_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter: {
                            state:["created", "illegitimate_duplicate", "cid_verification_pending"]
                          }
                    },
                    fetchPolicy:'network-only',
                  
                });
                log.success(MODULE_NAME, "get created assets result: ", res?.data?.getAssets?.data);
                if(res){
                  
                    let _data= res?.data?.getAssets?.data;
                    
                    let results = _data?.map((item:any)=>{
                      

                     
                        const imgUrl = item?.img;
                        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
                        const imgBBformat = imgUrl?.split('/');
                        const ibbFormat = imgBBformat[imgBBformat.length-3]
                     
                        let _img;
                         if(ibbFormat === "i.ibb.co"){
                            // _img =`${getassetsService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                            _img = item?.img
                         } 
                         else {
                            _img = item?.img
                            //  _img = `${getassetsService.imageServer}${urlFormat}/:/rs=h:500`
                         }
                          console.log("mui",_img)

                          if(item?.type === "audio"){
                              _img = item?.thumbnail ?? SOUND
                          }
                          if(item?.type === "video"){
                              _img = item?.thumbnail ?? VIDEO
                          }
                      
                     
                        return({
                            ...item,
                            img:_img,
                            price: item?.price?.map(item=>{
                                if(item?.type==='fiat'){
                                    return({
                                        ...item,
                                        locale: 'en-US',
                                    })
                                }
                                else{
                                    return({
                                        ...item,
                                        amount:(item?.amount)?.toFixed(3)
                                    })
                                }
                            }),
                            ribbon :item?.state ==="illegitimate_duplicate" ? {
                                backgroundColor:"red",
                                value:"Action Required"
                            } :(item?.state ==="cid_verification_pending"? {
                                backgroundColor:"#de5307",
                                value:"Verification Pending"
                            }:null),
                            tag: null,
                            networkType:null,
                            // category: item?.tag?.toLowerCase(),
                            tokenId:item?.serialNo,
                            serialNo:`Rare #/${item?.serialNo}`,
                            subtitle:item?.subtitle.replace(/<[^>]*>?/gm, ''),
                            audioDetail: item?.type === "audio" ? true : false,
                            videoDetail: item?.type === "video" ? true : false,
                           
                        })
                    })
                   console.log("RESUTLS",results)
                    return{
                        pagination: {
                            nextOffset: offset + res?.data?.getAssets?.pageSize,
                            totalItems: res?.data?.getAssets?.totalCount
                        },  
                        results
                    }
                }
              
              
            }
        } catch (err) {
            log.error(MODULE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }

//     async getAssets(size: number, offset: number) {
//         const graphqlModule = getGraphQLModule();
//         const client = graphqlModule.getClient("graphql-gateway");
//         try {
//             if (client) {
//                 const res = await client.query({
//                     query: LIST_ASSETS,
//                     variables: {
//                         size: size,
//                         offset: offset,
             
//                     },
//                 });
//                 log.success(MODULE_NAME, "getAssets: ", res);
//                 // return res?.data?.getAssets;
//                 console.log("nskk",res?.data?.getAssets)
//                 let _found = res?.data?.getAssets?.results;
//                 _found = _found.slice(offset, offset + size);
//                 return {
//                     pagination: {
//                         nextOffset: offset + _found.length,
//                         totalItems: res?.data?.getAssets?.results?.length,  
//                     },
//                     results: _found,
//                 }
//             }
//         } catch (err) {
//             log.error(MODULE_NAME, "error in get assets", err);
//             // throw Error(`${err?.message}`)
//             return {
//                 pagination: {
//                     nextOffset: 0,
//                     totalItems: 0,
//                 },
//                 results: [],
//             };
//         }
    
//    }

// async getAssets(size: number, offset: number) {
//     let _found = TEST_DATA;
//    _found = _found.slice(offset, offset + size);
//    return {
//        pagination: {
//            nextOffset: offset + _found.length,
//            totalItems: TEST_DATA?.length,  
//        },
//        results: _found,
//    }
// }
}
